import React from "react";

const Java_Methods = () => {
  return (
    <div>
      <h1>Java Methods</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Methods in Java.</p>
    </div>
  );
};

export default Java_Methods;
